import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import './css/styles.scss';
import Amplify from "aws-amplify";
import config from "./config";
// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom';


import { BrowserRouter as Router } from "react-router-dom";
// Material UI components.
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID
    },
    Storage: {
      region: config.s3.REGION,
      bucket: config.s3.BUCKET,
      identityPoolId: config.cognito.IDENTITY_POOL_ID
    },
    API: {
      endpoints: [
        {
          name: "topic",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "video",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "category",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "activity",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "language",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "country",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "organization",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "userdevice",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        },
        {
          name: "pushnotification",
          endpoint: config.apiGateway.PRODURL,
          region: config.apiGateway.REGION
        }
      ]
    }
  });

ReactDOM.render(

    <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
            <Router>
                <App/>
            </Router>
        </MuiThemeProvider>,

    document.getElementById('root')
);

 registerServiceWorker();